export const API_X_SOURCE = 'portailvente_web';

export enum VAPI_X_VERSION {
    V5 = '5',
}
export enum SAPIC_X_VERSION {
    V5 = '5',
}
